import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";

export default function NotFound() {
  return (
    <PublicLayout>
      <div className="py-32 text-center px-4">
        <div className="font-display text-7xl font-bold text-[#2472C8]">404</div>
        <h1 className="font-display text-2xl font-bold text-[#1B2A41] mt-4">Pagina non trovata</h1>
        <p className="text-[#566476] mt-2">La pagina che cerchi non esiste o è stata spostata.</p>
        <Link to="/" className="inline-block mt-6 bg-[#1B2A41] text-white font-semibold px-6 py-3 rounded-full">Torna alla home</Link>
      </div>
    </PublicLayout>
  );
}
